import qs from "qs";

export const cacheBustURL = (url: string) => url + '&d=' + new Date().getTime();
/** function to get query string data from url */
export const parsetUrlQueryParams = (url: string) => qs.parse(url.split('?')[1]);
// similar behavior as clicking on a link
export const redirectToURL = (url: string) => window.location.href = url;
